<template>
  <div class="box">
    <v-card class="pa-2 rounded-lg" style="width: 100%" outlined>
      <h1 style="padding-right: 10px">
        لینک‌های کوتاه‌شده
        <v-icon>mdi-link-variant</v-icon>
      </h1>
      <v-container fluid class="filter-sort">
        <v-row>
          <v-col cols="12" v-show="$vuetify.breakpoint.smAndDown">
            <v-btn
              class="btn-send-sms btn"
              @click="gotoShortUrl"
              :loading="loading"
              dense
              depressed
            >
              <v-icon>mdi-link-plus</v-icon>
              ساخت لینک کوتاه
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="itemsPerPage"
              :items="[5, 10, 15, 25, 50, 100, 200, 300, 500]"
              label="تعداد"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="searchQuery"
              label="جستجو"
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <v-select
              v-model="sortBy"
              :items="sortOpt"
              label="مرتب‌سازی "
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn
              class="btn-upload btn"
              @click="exportCsv"
              :loading="loading"
              dense
              depressed
              :disabled="filteredShortLinks.length === 0"
            >
              <v-icon>mdi-download</v-icon>
              دریافت
            </v-btn>
          </v-col>
          <v-col md="2" v-show="$vuetify.breakpoint.mdAndUp">
            <v-btn
              class="btn-send-sms btn"
              @click="gotoShortUrl"
              :loading="loading"
              dense
              depressed
            >
              <v-icon>mdi-link-plus</v-icon>
              ساخت لینک کوتاه
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <!-- table of links -->
      <v-container fluid>
        <v-data-table
          :headers="headers"
          :items="paginatedShortLinks"
          :search="searchQuery"
          hide-default-footer
          class="elevation-1"
          :loading="loadingTB"
        >
          <template slot="item.index" slot-scope="props">
            {{ props.index + 1 + (currentPage - 1) * itemsPerPage }}
          </template>

          <template slot="item.longUrl" slot-scope="props">
            <div class="contentbox">
              <v-btn class="ma-2" text icon small color="blue lighten-2">
                <v-tooltip left color="blue">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        copyToClipboard(props.item.longUrl, props.item.id)
                      "
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span class="custom-tooltip">کپی</span>
                </v-tooltip>
              </v-btn>
              <span class="link ellipsis d-inline-block text-truncate">
                {{ props.item.longUrl }}
              </span>
            </div>
          </template>
          <template slot="item.shortUrl" slot-scope="props">
            <div class="contentbox">
              <v-btn class="ma-2" text icon small color="blue lighten-2">
                <v-tooltip left color="blue" transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        copyToClipboard(props.item.shortUrl, props.item.id)
                      "
                      >mdi-content-copy</v-icon
                    >
                  </template>
                  <span>کپی</span>
                </v-tooltip>
              </v-btn>
              <span
                :style="{ color: !props.item.active ? 'red' : 'green' }"
                class="link ellipsis d-inline-block text-truncate"
                >{{ props.item.shortUrl }}
              </span>
            </div>
          </template>
          <template slot="item.views" slot-scope="props">
            {{ props.item.views }}
          </template>
          <template slot="item.ended_at" slot-scope="props">
            {{ convertedDate(props.item.ended_at) }}
          </template>
          <template slot="item.actions" slot-scope="props">
            <short-link-buttons :data="props.item" :meta="meta" />
            <!-- <v-menu left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item>
                  <v-btn
                    icon
                    color="red"
                    class="ma-0 ms-2"
                    @click="deleteShortLink(props.item)"
                  >
                    <v-icon size="20" title="حذف">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn
                    icon
                    class="ma-0 ms-2"
                    @click="ActiveShortLink(props.item)"
                  >
                    <v-icon
                      v-if="!props.item.active"
                      small
                      color="green"
                      title="فعال کردن"
                    >
                      mdi-link-variant
                    </v-icon>
                    <v-icon v-else small color="red" title="غیرفعال کردن">
                      mdi-link-variant-off
                    </v-icon>
                  </v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn icon class="ma-0 ms-2" @click="updateLink(props.item)">
                    <v-icon small color="blue" title="ویرایش">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu> -->
          </template>

          <!-- Body slot with fallback for empty data -->
          <template slot="body">
            <tr v-if="paginatedShortLinks.length === 0">
              <td
                :colspan="headers.length"
                style="
                  text-align: center;
                  vertical-align: middle;
                  height: 100px;
                "
              >
                <v-icon class="text-h1 mt-15 mb-15 px-4"
                  >mdi-link-variant</v-icon
                >
                لینکی برای نمایش وجود ندارد!
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>

      <!-- کنترل Pagination مستقل -->
      <v-divider></v-divider>
      <div class="w-100 text-center d-flex align-start py-2 px-6 flex-wrap">
        <div
          class="d-flex v-card v-card--flat v-sheet theme--light"
          style="max-width: 200px"
        >
          <span class="text-no-wrap me-2 mt-md-3">برو به صفحه:</span>
          <v-text-field
            v-model.number="gotoPage"
            dense
            outlined
            type="number"
            :max="maxPage"
            :min="1"
            @input="changePage"
          ></v-text-field>
        </div>
        <div class="spacer"></div>
        <v-pagination v-model="currentPage" :length="maxPage"></v-pagination>
      </div>

      <!-- دیالوگ تایید حذف -->
      <custom-popup
        max-width="500"
        v-model="dialog"
        :cons="deletecons"
        :loading.sync="loading"
        @action="handleDeleteAction"
      >
        <v-card>
          <v-card-text>
            <div class="text-center pa-4">
              <p>آیا مطمئن هستید که می‌خواهید این مورد حذف شود؟</p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deletesl" outlined color="success">تایید</v-btn>
            <v-btn text @click="dialog = false" outlined color="error"
              >لغو</v-btn
            >
          </v-card-actions>
        </v-card>
      </custom-popup>
      <!--Edit-->
      <edit-shortlink
        @updateList="initData"
        v-model="selectedDialog"
        :item="selectedItem"
      ></edit-shortlink>
    </v-card>
  </div>
</template>

<script>
import EditShortlink from "./EditShortlink.vue";
import moment from "moment-jalaali";
import "@/assets/css/style.shortlink.css";
import {
  GetDomian,
  GetLinks,
  DeleteLink,
  EditLink,
} from "./axios_shortlink.js";

import {
  convertTableToCsv,
  downloadCvsFile,
} from "@/assets/js/FunctionLink.js";
import ShortLinkButtons from "./shortLinkButtons.vue";
import customPopup from "../../../core/plugins/TitleRibbon/plugins/popup/customPopup.vue";
export default {
  name: "showShortLinkTable",
  components: { EditShortlink, ShortLinkButtons, customPopup },
  data() {
    return {
      deletecons: {
        title: "تایید حذف",
        buttons: [
          {
            type: "submit",
            handler: this.deletesl,
          },
          {
            type: "close",
            handler: () => {
              this.dialog = false;
            },
          },
        ],
      },
      meta: {
        buttons: [
          {
            name: "toggleActive",
            label: "تغییر وضعیت",
            icon: "link-variant",
            class: "btn-activate border-2 rounded-pill",
            action: this.ActiveShortLink,
          },
          {
            name: "edit",
            label: "ویرایش",
            icon: "pencil",
            class: "btn-edit border-2 rounded-pill",
            action: this.updateLink,
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-can",
            class: "btn-delete rounded-pill",
            action: this.deleteShortLink,
          },
        ],
      },
      loadingTB: true,
      ShortLinks: [],
      selectedDialog: false,
      selectedItem: null,
      loading: false,
      searchQuery: "",
      sortBy: null,
      sortOpt: [
        { text: "جدیدترین", value: "newer_desc" },
        { text: "قدیمی‌ترین", value: "older_desc" },
        { text: "محبوب‌ترین", value: "views_desc" },
        { text: "فعال", value: "active_desc" },
        { text: "طولانی‌ترین لینک", value: "longUrl_desc" },
        { text: "کوتاه‌ترین لینک", value: "longUrl_asc" },
      ],
      dialog: false,
      selectForDelete: null,
      currentPage: 1,
      itemsPerPage: 5,
      gotoPage: 1,
      headers: [
        {
          text: "ردیف",
          value: "index",
          sortable: false,
          class: "text-center",
          align: "start",
          cellClass: "text-right",
        },
        {
          text: "عنوان",
          value: "title",
          class: "text-center",
          align: "start",
          cellClass: "text-right",
        },
        {
          text: "لینک",
          value: "longUrl",
          class: "text-center",
          align: "start",
          cellClass: "text-end ltr-text",
        },
        {
          text: "لینک کوتاه",
          value: "shortUrl",
          class: "text-center",
          align: "start",
          cellClass: "text-end ltr-text",
        },
        {
          text: "تعداد کلیک",
          class: "text-center",
          align: "start",
          value: "views",
          cellClass: "text-right",
        },
        {
          text: "تاریخ انقضا",
          class: "text-center",
          align: "start",
          value: "ended_at",
          cellClass: "text-right",
        },
        {
          text: "مدیریت",
          value: "actions",
          sortable: false,
          class: "text-center",
          align: "start",
          cellClass: "text-center",
        },
      ],
    };
  },
  created() {
    this.initData();
  },
  watch: {
    ShortLinks: {
      deep: true,
      handler(newValue) {
        console.log("ShortLinks updated:", newValue);
      },
    },
  },
  computed: {
    filteredShortLinks() {
      let filtered = [...this.ShortLinks];
      filtered.sort((a, b) => {
        if (a.active !== b.active) {
          return b.active - a.active;
        }
        const dateA = new Date(a.updated_at || a.create_at || "1970-01-01");
        const dateB = new Date(b.updated_at || b.create_at || "1970-01-01");
        return dateB - dateA;
      });
      if (this.searchQuery) {
        filtered = filtered
          .filter(
            (item) =>
              item.longUrl
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase()) ||
              item.shortUrl
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
          )
          .sort((a, b) => {
            if (a.active !== b.active) {
              return b.active - a.active;
            }
            const dateA = new Date(a.updated_at || a.create_at || "1970-01-01");
            const dateB = new Date(b.updated_at || b.create_at || "1970-01-01");
            return dateB - dateA;
          });
      }
      switch (this.sortBy) {
        case "newer_desc":
          filtered.sort((a, b) => new Date(a.creat_at) - new Date(b.creat_at));
          break;
        case "older_desc":
          filtered.sort((a, b) => new Date(b.creat_at) - new Date(a.creat_at));
          break;
        case "views_desc":
          filtered.sort((a, b) => b.views - a.views);
          break;
        case "active_desc":
          filtered.sort((a, b) => b.active - a.active);
          break;
        case "longUrl_asc":
          filtered.sort((a, b) => a.longUrl.length - b.longUrl.length);
          break;
        case "longUrl_desc":
          filtered.sort((a, b) => b.longUrl.length - a.longUrl.length);
          break;
        default:
          break;
      }
      console.log("filtered", filtered);

      this.loadingTB = false;
      return filtered;
    },
    paginatedShortLinks() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredShortLinks.slice(start, end);
    },
    maxPage() {
      return Math.ceil(this.filteredShortLinks.length / this.itemsPerPage);
    },
  },

  methods: {
    handleDeleteAction(type) {
      if (type === "submit") {
        this.deletesl();
      } else if (type === "close") {
        this.dialog = false;
      }
    },
    convertedDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid()
        ? moment(date, "YYYY-MM-DD HH:mm:ss")
            .locale("fa")
            .format("jYYYY/jMM/jDD HH:mm:ss")
        : "";
    },
    initData() {
      this.loadingTB = true;
      GetLinks()
        .then((data) => {
          console.log("data: ", data);

          if (Array.isArray(data)) {
            this.ShortLinks = data;
          } else {
            console.log("داده‌های دریافت‌شده آرایه نیستند:", data);
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت داده:", error);
        })
        .finally(() => {
          this.loadingTB = false;
        });
    },

    showSnackbar(message, color) {
      this.snackbar = false;
      this.$nextTick(() => {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
      });
    },

    exportCsv() {
      let csvContent = convertTableToCsv(this.headers, this.filteredShortLinks);
      downloadCvsFile(csvContent, "table_data.csv");
    },
    gotoShortUrl() {
      this.$router.push("/new");
    },
    copyToClipboard(text, id) {
      if (
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === "function"
      ) {
        // Ensure browser compatibility
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.showSnackbar("لینک با موفقیت کپی شد!", "success");
            // this.countView(id);
          })
          .catch((err) => {
            console.error("خطای کپی کردن لینک:", err);
          });
      } else {
        // Fallback for unsupported browsers
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.showSnackbar("کپی کردن لینک انجام شد!", "success");
          // this.countView(id);
        } catch (err) {
          console.error("خطا در کپی کردن لینک:", err);
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },
    deleteShortLink(item) {
      console.log("deleteShortLink called with:", item);
      this.selectedItem = item; //
      this.dialog = true;
    },
    ActiveShortLink(item) {
      let link = this.ShortLinks?.find((p) => p.id === item.id);
      if (!link) return;
      EditLink(item.id, { active: !link.active })
        .then(() => {
          this.initData();
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("خطا در بروزرسانی تعداد بازدید:", error);
        });
    },
    deletesl() {
      if (this.selectedItem) {
        // this.removeShortLink(this.ShortLinks[this.selectForDelete]);
        DeleteLink(this.selectedItem.id)
          .then(() => {
            this.initData();
            this.dialog = false;
            this.selectedItem = null;
          })
          .catch((error) => {
            console.error("خطا در حذف داده:", error);
          });
      }
    },
    updateLink(item) {
      //open modaledit
      this.selectedDialog = true;
      this.selectedItem = item;
    },
    changePage() {
      if (this.gotoPage > 0 && this.gotoPage <= this.maxPage) {
        this.currentPage = this.gotoPage;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table >>> tbody tr:nth-child(odd) {
  background-color: #ebedf3;
}
.v-data-table >>> .v-data-table-header-mobile__wrapper {
  justify-content: flex-end;
}
.bottom-sticky {
  position: sticky;
  bottom: 0;
}
.box {
  background-color: #fff;
  box-shadow: 5px 5px 5px #7e8299;
  border-radius: 10px;
  padding: 1px;
  width: 100%;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.combined-column {
  display: flex;
  flex-direction: column;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  text-align: left !important;
}
@media (max-width: 780px) {
  .ellipsis {
    max-width: 60px !important;
    text-align: left !important;
  }
}
.contentbox {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: baseline;
  align-content: baseline;
  direction: ltr;
}
.btn {
  width: 100%;
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.ltr-text {
  direction: ltr;
  text-align: left;
}
</style>
